import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { Loan } from 'src/generated-api-client';
import { AgentLoanListItem } from 'src/pages/AgentLoansPage/AgentLoanListItem';
import { AgentLoansHeaderPanel } from 'src/pages/AgentLoansPage/AgentLoansFilterPanel';
import { AgentLoansStore } from 'src/stores/AgentLoansStore/AgentLoansStore';

const store = AgentLoansStore;

export const AgentLoansPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="agent-loans"
            store={store}
            asidePanel={<AgentLoansAsidePanel />}
        >
            <EntityPresentation store={store} entityName="agent-loan" />
        </MasterDetailsPage>
    );
});

const AgentLoansAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(item: Loan) => {
                return (
                    <List.Item key={item.id}>
                        <AgentLoanListItem item={item} />
                    </List.Item>
                );
            }}
            header={<AgentLoansHeaderPanel />}
        />
    );
});
